var render = function render(_c,_vm){return _c('article',[_c('h2',{staticClass:"text-center main-heading",domProps:{"innerHTML":_vm._s(_vm.props.heading)}}),_c('p',{staticClass:"main-description text-center mx-auto managers-council__text",domProps:{"innerHTML":_vm._s(_vm.props.paraghText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }